var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6025_9659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 57.0002H26.8889V30.1113H0V57.0002ZM20.8854 41.8257V45.159H9.33678V47.6635H20.8854V50.9969H6.00344V36.1148H20.8854V39.4481H9.33678V41.8257H20.8854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.8889H26.8889V0H0V26.8889ZM20.8854 11.7778V20.8854H6.00344V17.5521H17.5521V15.1111H6.00344V6.00344H20.8854V9.33678H9.33678V11.7778H20.8854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1113 57.0002H57.0002V30.1113H30.1113V57.0002ZM43.5558 48.5309L39.4481 40.8674V51.2338H36.1148V36.1148H40.6825L43.5558 41.475L46.4289 36.1147H50.9967V51.2337H47.6633V40.8673L43.5558 48.5309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1113 0V26.8889H57.0002V0H30.1113ZM35.8778 9.33678V6.00344H51.2337V9.33678H45.2224V21.1224H41.8891V9.33678H35.8778Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6025_9659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord32);
export default __webpack_public_path__ + "static/media/accord_32.709f9505c8db80a33d5ffa34831dc78b.svg";
export { ForwardRef as ReactComponent };